import { OrderFormat as s, DayOfWeek as g, IntervalType as p, IntervalState as l } from "@ancon/wildcat-types";
import F from "moment";
import { DaysOfWeekMap as x } from "../shared/constants.mjs";
import d from "../date/createLocalTimezoneMoment.mjs";
import f from "./getExpressServiceIntervalStart.mjs";
import c from "./getExpressServiceIntervalEnd.mjs";
import "../time/getTimeSpanParts.mjs";
const D = [s.TakeAway, s.EatIn];
function A(m) {
  var i;
  if (!((i = m.openingHours) != null && i.length))
    return [];
  const t = F(), { openingHours: u, supportedOrderFormats: y, timeZoneOffset: o } = m, O = [...u].reduce(
    (r, e, I, T) => {
      switch (e.type) {
        case p.Exception:
          {
            const a = d(e.periodFrom), n = d(e.periodTo), k = f(
              a,
              e,
              o
            ), E = c(
              n,
              e,
              o
            );
            if (t.isBetween(k, E, void 0, "[]"))
              return e.state === l.Closed ? (T.splice(1), s.None) : e.orderFormat;
          }
          break;
        case p.Normal:
        default:
          if (
            // Every day in the week
            e.dayOfWeek === g.Everyday || // Specific day in the week
            e.dayOfWeek === x[t.isoWeekday()]
          ) {
            const a = f(
              t,
              e,
              o
            ), n = c(
              t,
              e,
              o
            );
            if (t.isBetween(a, n, void 0, "[]"))
              return r | e.orderFormat;
          }
          break;
      }
      return r;
    },
    s.None
  );
  return D.filter(
    (r) => (
      // Check if the order format is available
      (O & r) === r && // Check if the order format is supported by the outlet
      (y & r) === r
    )
  );
}
export {
  A as default
};
